import React, { useEffect, useState } from 'react';
import { Box, Grid } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import SectionHeader from '@monorepo/shared/src/components/layout/SectionHeader';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';
import WithQuery from '@monorepo/shared/src/components/common/WithQuery';
import useClassrooms from 'state/hooks/use-classrooms';
import useTeachingOrderStore from 'graph/state/query-hooks/use-teaching-order';
import useTeachingOrder from 'state/hooks/use-teaching-order';
import useAssignments from 'state/hooks/use-assignments';
import AssignmentCard from './AssignmentCard';
import AssignmentHeader from './AssignmentHeader';
import useTrialUserOmitRoutes from 'state/hooks/use-trial-user-omit-routes';

const tAssignment = (key) => translate('assignment', key);

const AssignmentsGrid: React.FC = () => {
  const [{ activeCharacters }] = useTeachingOrder();
  const [{ isLoading, error }] = useTeachingOrderStore();

  const omitRoutes = useTrialUserOmitRoutes();
  const [, { setAllGroups }] = useAssignments();

  const [{ activeClassroom }] = useClassrooms();

  const [cardItems, setCardItems] = useState<any[]>([]);
  const classes = useStyles();

  useEffect(() => {
    const characters = activeCharacters?.map((charObj) => charObj?.character);
    setCardItems(characters);
  }, [activeCharacters]);

  useEffect(() => {
    if (activeClassroom?.groups?.length) {
      setAllGroups(activeClassroom?.groups);
    }
  }, [activeClassroom]);

  return (
    <>
      <SectionHeader
        omitRoutes={omitRoutes}
        showDashboardIcon
        hamburgerMenu
        title={tAssignment('header')}
      />
      <WithQuery loading={isLoading} error={error}>
        <Box style={{ margin: '50px' }}>
          <AssignmentHeader name={activeClassroom?.name} />
          <Grid container spacing={1} className={classes.grid}>
            {cardItems?.map((item) => (
              <AssignmentCard key={item} letter={item} />
            ))}
          </Grid>
        </Box>
      </WithQuery>
    </>
  );
};

const useStyles = makeStyles(() => ({
  grid: {
    flexGrow: 1,
  },
}));

export default AssignmentsGrid;
